"use strict";
/**
 * Do not edit directly
 * This file is automatically generated
 **/
Object.defineProperty(exports, "__esModule", { value: true });
exports.dark = void 0;
exports.dark = {
    "background": {
        "default": "#000000",
        "contrast": "#1a1a1a",
        "hover": "rgba(255, 255, 255, 0.15)",
        "selected": "rgba(255, 255, 255, 0.25)",
        "overlay": "#1a1a1a",
        "primary": "#160c34",
        "critical": "#2c120a",
        "warning": "#332107",
        "success": "#0e1f14",
        "highlighted": {
            "primary": "#8265dc",
            "success": "#459B64",
            "warning": "#E6A03B",
            "critical": "#D4613A"
        },
        "level0": "#000000",
        "level1": "#1A1A1A",
        "info": "#011D2E"
    },
    "border": {
        "default": "#333333",
        "form": "#858585",
        "contrast": "#484848",
        "selected": "#ffffff",
        "primary": "#351d7c",
        "success": "#2b5f3d",
        "warning": "#825412",
        "critical": "#76301b",
        "formCritical": "#D4613A",
        "accessibleBorder": "#858585",
        "info": "#005180"
    },
    "content": {
        "default": "#ffffff",
        "subdued": "#858585",
        "disabled": "#8C8C8C",
        "placeholder": "#858585",
        "primary": "#8265dc",
        "success": "#459B64",
        "warning": "#E6A03B",
        "critical": "#D4613A",
        "accent": {
            "success": "#459B64",
            "warning": "#E6A03B",
            "critical": "#D4613A"
        },
        "above": {
            "primary": "#000000",
            "secondary": "#ffffff",
            "text": "#ffffff",
            "contrast": "#ffffff",
            "critical": "#D4613A"
        },
        "info": "#3FB7FC"
    },
    "interactive": {
        "primary": {
            "default": "#ffffff",
            "hover": "#f2f2f2",
            "pressed": "#dbdbdb"
        },
        "secondary": {
            "default": "#2e2e2e",
            "hover": "#212121",
            "pressed": "#0a0a0a"
        },
        "contrast": {
            "default": "#4b5367",
            "hover": "rgba(75, 83, 103, 0.9)",
            "pressed": "rgba(75, 83, 103, 0.75)"
        },
        "text": {
            "default": "rgba(255, 255, 255, 0)",
            "hover": "rgba(255, 255, 255, 0.1)",
            "pressed": "rgba(255, 255, 255, 0.12)"
        },
        "critical": {
            "default": "#2c120a",
            "hover": "#3f1a0e",
            "pressed": "#602716"
        },
        "disabled": "#232529"
    },
    "benefits": {
        "mealVoucher": {
            "content": {
                "default": "#EF1090",
                "selected": "#f458b1"
            },
            "background": {
                "default": "#30031d",
                "selected": "#710744"
            }
        },
        "gift": {
            "content": {
                "default": "#F35728",
                "selected": "#f78969"
            },
            "background": {
                "default": "#360f03",
                "selected": "#762107"
            }
        },
        "mobility": {
            "content": {
                "default": "#48A202",
                "selected": "#77fc10"
            },
            "background": {
                "default": "#0e2000",
                "selected": "#2d6800"
            }
        },
        "personalWallet": {
            "content": {
                "default": "#0392E5",
                "selected": "#3fb7fc"
            },
            "background": {
                "default": "#011d2e",
                "selected": "#024872"
            }
        },
        "cashback": {
            "content": {
                "default": "#CA7628",
                "selected": "#e09f62"
            },
            "background": {
                "default": "#281808",
                "selected": "#623b14"
            }
        }
    },
    "social": {
        "pot": {
            "content": {
                "default": "#0392E5",
                "selected": "#3fb7fc"
            },
            "background": {
                "default": "#011d2e",
                "selected": "#024872"
            }
        },
        "activity": {
            "content": {
                "default": "#48A202",
                "selected": "#77fc10"
            },
            "background": {
                "default": "#0e2000",
                "selected": "#2d6800"
            }
        },
        "pulse": {
            "content": {
                "default": "#1CA07B",
                "selected": "#3fddb1"
            },
            "background": {
                "default": "#062019",
                "selected": "#115c48"
            }
        },
        "praise": {
            "default": {
                "content": {
                    "default": "#EF1090",
                    "selected": "#f458b1"
                },
                "background": {
                    "default": "#30031d",
                    "selected": "#710744"
                }
            },
            "birthday": {
                "content": {
                    "default": "#8265dc",
                    "selected": "#a893e7"
                },
                "background": {
                    "default": "#160c34",
                    "selected": "#2d196a"
                }
            },
            "celebration": {
                "content": {
                    "default": "#EF1090",
                    "selected": "#f458b1"
                },
                "background": {
                    "default": "#30031d",
                    "selected": "#710744"
                }
            },
            "congrats": {
                "content": {
                    "default": "#48A202",
                    "selected": "#77fc10"
                },
                "background": {
                    "default": "#0e2000",
                    "selected": "#2d6800"
                }
            },
            "egoboost": {
                "content": {
                    "default": "#0392E5",
                    "selected": "#3fb7fc"
                },
                "background": {
                    "default": "#011d2e",
                    "selected": "#024872"
                }
            },
            "onboarding": {
                "content": {
                    "default": "#CA7628",
                    "selected": "#e09f62"
                },
                "background": {
                    "default": "#281808",
                    "selected": "#623b14"
                }
            },
            "proanniversary": {
                "content": {
                    "default": "#F35728",
                    "selected": "#f78969"
                },
                "background": {
                    "default": "#360f03",
                    "selected": "#762107"
                }
            },
            "procelebration": {
                "content": {
                    "default": "#F35728",
                    "selected": "#f78969"
                },
                "background": {
                    "default": "#360f03",
                    "selected": "#762107"
                }
            },
            "thanks": {
                "content": {
                    "default": "#EF1090",
                    "selected": "#f458b1"
                },
                "background": {
                    "default": "#30031d",
                    "selected": "#710744"
                }
            }
        },
        "article": {
            "content": {
                "default": "#CA7628",
                "selected": "#e09f62"
            },
            "background": {
                "default": "#281808",
                "selected": "#623b14"
            }
        }
    },
    "cards": {
        "black": {
            "primary": "#111111",
            "accent": "#272727"
        },
        "grey": {
            "primary": "#585858",
            "accent": "#e5e5e5"
        },
        "midnightBlue": {
            "primary": "#00084b",
            "accent": "#e5e8ff"
        },
        "gold": {
            "primary": "#c8ba95",
            "accent": "#f3f0e7"
        },
        "pink": {
            "primary": "#edc2bd",
            "accent": "#f7e5e3"
        }
    },
    "title": {
        "red": "#FF2055",
        "blue": "#336DFF",
        "magenta": "#E40AAF",
        "indigo": "#A51CF1"
    },
    "travel": {
        "hotel": {
            "purpleBase": "#631191",
            "purpleLight": "#C060F5",
            "pinkBase": "#FFA6BB",
            "pinkLight": "#FFD2DD"
        },
        "rental": {
            "redBase": "#991333",
            "redLight": "#FF6388",
            "orangeBase": "#FFD1B3",
            "orangeLight": "#FFE8D9"
        },
        "train": {
            "greenBase": "#008C6B",
            "greenLight": "#4CF0C9",
            "limeBase": "#DFF6AF",
            "limeLight": "#EFFAD7"
        },
        "plane": {
            "blueBase": "#1F4199",
            "blueLight": "#6FCFFE",
            "mintBase": "#99F7E0",
            "mintLight": "#CCFBF0"
        }
    }
};
